import React from "react";
import { PhoneOutlined } from "@ant-design/icons";
import { RenglonSemaforo } from "../RenglonSemaforo";
import { TituloSemaforo } from "../TituloSemaforo";

export const PorContactarUsuario = ({ asistenciasSemaforo }) => {
  const asistencias = asistenciasSemaforo.filter(
    (a) => a.estatusID === 3 || a.estatusID === 4
  );

  return (
    <section className="semaforo-general__columna" aria-label="Por contactar usuario">
      <TituloSemaforo
        icon={<PhoneOutlined />}
        titulo="Proveedor asignado - Por arribar"
        count={asistencias.length}
      />
      {asistencias.length === 0 && <p className="semaforo-general__vacio">Sin asistencias por contactar</p>}
      {asistencias.map((a) => <RenglonSemaforo key={a.asistenciaID} asistencia={a} fecha={a.fechaAsignacion} />)}
    </section>
  );
};
